import { BiddingBetDTO } from '../../../../Domain/DTO/BiddingBetDTO';

export class BiddingBetExtendedDTO extends BiddingBetDTO {
    MaxBetValue: number;
    MinBetValue: number;
}